// 9fbef606107a605d69c0edbcd8029e5d
import { ADDRESSBOOK_ACTION_PATTERN } from '../../../../constants/reducer.constants';

const ADDRESS_BOOK_CONSTANTS = {
  GET_ADDRESS_LIST: `${ADDRESSBOOK_ACTION_PATTERN}GET_ADDRESS_LIST`,
  SET_ADDRESS_LIST: `${ADDRESSBOOK_ACTION_PATTERN}SET_ADDRESS_LIST`,
  SET_DEFAULT_SHIPPING_ADDRESS_REQUEST: `${ADDRESSBOOK_ACTION_PATTERN}SET_DEFAULT_SHIPPING_ADDRESS`,
  SET_DEFAULT_SHIPPING_ADDRESS_SUCCESS: `${ADDRESSBOOK_ACTION_PATTERN}SET_DEFAULT_SHIPPING_ADDRESS_SUCCESS`,
  SET_DEFAULT_SHIPPING_ADDRESS_FAILED: `${ADDRESSBOOK_ACTION_PATTERN}SET_DEFAULT_SHIPPING_ADDRESS_FAILED`,
  LOAD_ADD_ADDRESS_COMPONENT: `${ADDRESSBOOK_ACTION_PATTERN}LOAD_ADD_ADDRESS_COMPONENT`,
  LOAD_ADDRESSBOOK_COMPONENT: `${ADDRESSBOOK_ACTION_PATTERN}LOAD_ADDRESSBOOK_COMPONENT`,
  UPDATE_ADDRESS_LIST_ON_DELETE: `${ADDRESSBOOK_ACTION_PATTERN}UPDATE_ADDRESS_LIST_ON_DELETE`,
  UPDATE_ADDRESS_LIST_ON_DELETE_ERR: `${ADDRESSBOOK_ACTION_PATTERN}UPDATE_ADDRESS_LIST_ON_DELETE_ERR`,
  DELETE_ADDRESS: `${ADDRESSBOOK_ACTION_PATTERN}DELETE_ADDRESS`,
  DELETE_MODAL_MOUNTED_STATE: `${ADDRESSBOOK_ACTION_PATTERN}DELETE_MODAL_MOUNTED_STATE`,
  CLEAR_GET_ADDRESS_LIST_TTL: `${ADDRESSBOOK_ACTION_PATTERN}CLEAR_GET_ADDRESS_LIST_TTL`,
  SHOW_LOADER: `${ADDRESSBOOK_ACTION_PATTERN}SHOW_LOADER`,
  HIDE_LOADER: `${ADDRESSBOOK_ACTION_PATTERN}HIDE_LOADER`,
  SET_ADDRESS_BOOK_NOTIFICATION: `${ADDRESSBOOK_ACTION_PATTERN}SET_ADDRESS_BOOK_NOTIFICATION`,
  GET_ADDRESS_LIST_TTL: 0,
  VERIFICATION_MODAL: 'VerificationModal',
  ADD_ADDRESS_MODAL: 'AddAddress',
  CLEAR_ERROR_STATE: 'CLEAR_ERROR_STATE',
  DEFAULT_SHIPPING_BILLING: 'ShippingAndBilling',
  GET_ADDRESS_LIST_PLCC: 'GET_ADDRESS_LIST_PLCC',
};

export default ADDRESS_BOOK_CONSTANTS;
